module.exports = __webpack_public_path__ + "static/img/200109.a00396bd.png";